(() => {
  if (window.__findStateBound) return;
  window.__findStateBound = true;

  const readStates = () => {
    const node = document.querySelector('[data-find-states]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return [];
    }
  };

  const states = readStates();
  const byCode = new Map(states.map((state) => [state.code, state]));

  document.querySelectorAll('[data-find-hero]').forEach((form) => {
    const select = form.querySelector('select');
    if (!select || select.dataset.ready) return;
    select.dataset.ready = 'true';
    states.forEach((state) => {
      const option = document.createElement('option');
      option.value = state.code;
      option.textContent = state.name;
      select.append(option);
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const state = byCode.get(select.value);
      if (!state) {
        document.getElementById('find-state-map')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (state.available && state.url) {
        window.location.assign(state.url);
        return;
      }
      document.dispatchEvent(new CustomEvent('find-state:select', { detail: state }));
      document.getElementById('find-state-map')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  document.querySelectorAll('[data-find-skip]').forEach((skip) => {
    const grid = skip.closest('.find-grid');
    const faq = document.getElementById('page-faq');
    if (!grid || !faq) return;
    const update = () => {
      const rect = grid.getBoundingClientRect();
      const scrollingGrid = rect.top < window.innerHeight * 0.35 && rect.bottom > window.innerHeight * 0.45;
      skip.classList.toggle('is-visible', scrollingGrid);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  });

  document.querySelectorAll('[data-find-map]').forEach((section) => {
    const map = section.querySelector('[data-map]');
    const tip = section.querySelector('[data-tip]');
    const stage = section.querySelector('[data-stage]');
    if (!map || !tip || !stage) return;

    const nameEl = tip.querySelector('[data-name]');
    const statusEl = tip.querySelector('[data-status]');
    const linkEl = tip.querySelector('[data-link]');
    const soonLabel = section.dataset.soonLabel || 'Currently not available';
    const availableLabel = section.dataset.availableLabel || 'THC-A Delivery Available!';
    const viewLabel = section.dataset.viewLabel || 'View state';
    let lockedCode = null;
    let source = null;
    let current = null;
    let hideTimer = null;

    const hideTip = (force = false) => {
      if (lockedCode && !force) return;
      window.clearTimeout(hideTimer);
      map.querySelectorAll('path.is-selected').forEach((path) => path.classList.remove('is-selected'));
      tip.hidden = true;
      source = null;
      current = null;
      if (force) lockedCode = null;
    };

    const scheduleHide = () => {
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => {
        if (source === 'hover') hideTip();
      }, 140);
    };

    const positionTip = (state) => {
      const path = map.querySelector(`path.${state.code}`);
      if (!path || window.matchMedia('(max-width: 749px)').matches) return;
      const stageRect = stage.getBoundingClientRect();
      const pathRect = path.getBoundingClientRect();
      const tipRect = tip.getBoundingClientRect();
      const gap = 12;
      const padding = 8;
      const right = pathRect.right - stageRect.left + gap;
      const leftSide = pathRect.left - stageRect.left - tipRect.width - gap;
      let left = right + tipRect.width <= stageRect.width - padding ? right : leftSide;
      left = Math.max(padding, Math.min(left, stageRect.width - tipRect.width - padding));
      const centered = pathRect.top - stageRect.top + (pathRect.height - tipRect.height) / 2;
      const top = Math.max(padding, Math.min(centered, stageRect.height - tipRect.height - padding));
      tip.style.left = `${left}px`;
      tip.style.top = `${top}px`;
    };

    const showTip = (state, nextSource = 'click') => {
      if (!state) return;
      if ((nextSource === 'hover') && lockedCode) return;
      window.clearTimeout(hideTimer);
      if (nextSource === 'search') lockedCode = state.code;
      current = state;
      source = nextSource;
      map.querySelectorAll('path.is-selected').forEach((path) => path.classList.remove('is-selected'));
      map.querySelector(`path.${state.code}`)?.classList.add('is-selected');
      nameEl.textContent = state.name;
      statusEl.textContent = state.available ? availableLabel : soonLabel;
      const ruleEl = tip.querySelector('[data-rule]');
      if (state.available && state.url) {
        linkEl.href = state.url;
        linkEl.hidden = false;
        if (ruleEl) ruleEl.hidden = false;
        const label = linkEl.querySelector('span');
        if (label) label.textContent = viewLabel;
      } else {
        linkEl.hidden = true;
        if (ruleEl) ruleEl.hidden = true;
      }
      tip.hidden = false;
      positionTip(state);
    };

    const bindPaths = () => {
      states.forEach((state) => {
        const path = map.querySelector(`path.${state.code}`);
        if (!path || path.dataset.mapReady) return;
        path.dataset.mapReady = 'true';
        path.classList.add(state.available ? 'is-available' : 'is-soon');
        path.setAttribute('aria-label', `${state.name}: ${state.available ? availableLabel : soonLabel}`);
        if (state.available) {
          path.setAttribute('tabindex', '0');
          path.setAttribute('role', 'button');
        }
        path.addEventListener('mousedown', (event) => event.preventDefault());
        path.addEventListener('click', () => {
          if (state.available && state.url) window.location.assign(state.url);
        });
        path.addEventListener('mouseenter', () => showTip(state, 'hover'));
        path.addEventListener('mouseleave', () => {
          if (source === 'hover') scheduleHide();
        });
        path.addEventListener('focus', () => showTip(state, 'hover'));
        path.addEventListener('blur', () => {
          if (source === 'hover') scheduleHide();
        });
        path.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (state.available && state.url) window.location.assign(state.url);
        });
      });
    };

    bindPaths();
    if (!map.querySelector('svg') && map.dataset.mapSrc) {
      fetch(map.dataset.mapSrc)
        .then((response) => {
          if (!response.ok) throw new Error('Map request failed');
          return response.text();
        })
        .then((markup) => {
          map.innerHTML = markup;
          bindPaths();
        })
        .catch(() => {
          map.classList.add('is-empty');
        });
    }

    tip.addEventListener('mouseenter', () => window.clearTimeout(hideTimer));
    tip.addEventListener('mouseleave', scheduleHide);
    tip.querySelector('[data-close]')?.addEventListener('click', () => hideTip(true));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !tip.hidden) hideTip(true);
    });
    window.addEventListener('resize', () => {
      if (current && !tip.hidden) positionTip(current);
    });

    document.addEventListener('find-state:select', (event) => {
      showTip(event.detail, 'search');
    });
  });
})();
